import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=144c5bb2&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"
import style0 from "./Trade.vue?vue&type=style&index=0&id=144c5bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c5bb2",
  null
  
)

export default component.exports